module.exports = __webpack_public_path__ + "static/img/48-2.2935086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/48-2.jpg
// module id = 0WZz
// module chunks = 0